export default __webpack_public_path__ + "static/media/Help_Assistant.30e93e76.svg";